module.exports = __webpack_public_path__ + "img/note_form.3aa1e59e.png";